import React, { useContext } from 'react';
import { AngularServicesContext } from 'react-app';
import t from 'react-translate';
import AdvancedSettingsSwitch from 'institutions/components/advanced-settings-switch';
import SectionContent from '../section-content';

const SftpIntegration = () => {
  const { InstitutionsManager } = useContext(AngularServicesContext);

  return (
    <SectionContent
      header={t.INSTITUTIONS.ADVANCED_SETTINGS.SFTP.TITLE()}
      description={[
        t.INSTITUTIONS.ADVANCED_SETTINGS.SFTP.DESCRIPTION_1(),
        t.INSTITUTIONS.ADVANCED_SETTINGS.SFTP.DESCRIPTION_2(),
        InstitutionsManager.institution.isDailySftpReportEnabled
          ? t.INSTITUTIONS.ADVANCED_SETTINGS.SFTP.ENABLED_DESCRIPTION()
          : t.INSTITUTIONS.ADVANCED_SETTINGS.SFTP.DESCRIPTION_3(),
      ]}
      // The switch is visible only when it is enabled, and the user cannot manually toggle it.
      extras={InstitutionsManager.institution.isDailySftpReportEnabled ? (
        <div className='d-flex align-self-start'>
          <AdvancedSettingsSwitch
            value='vm.InstitutionsManager.institution.isDailySftpReportEnabled'
            tooltipText={t.INSTITUTIONS.ADVANCED_SETTINGS.SFTP.TOOLTIP()}
            disabled
            tooltipEnabled
          />
        </div>
      ) : null}
    />
  );
};

export default SftpIntegration;
